import { render, staticRenderFns } from "./receiptPreviewer.vue?vue&type=template&id=4a10427d&scoped=true"
import script from "./receiptPreviewer.vue?vue&type=script&lang=js"
export * from "./receiptPreviewer.vue?vue&type=script&lang=js"
import style0 from "./receiptPreviewer.vue?vue&type=style&index=0&id=4a10427d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a10427d",
  null
  
)

export default component.exports